export default __webpack_public_path__ + "static/media/amboselidark.24a97451.png";